import { type ReactElement, useState } from 'react';
import { orderErrorMessage } from '@/shared/lib';
import { Button } from '@/shared/ui';
import { useReissueTaxInvoice } from '../model/use-reissue-tax-invoice';

export const ReissueTaxInvoiceButton = ({
  orderId,
}: {
  readonly orderId: string;
}): ReactElement => {
  const reissue = useReissueTaxInvoice();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async () => {
    setPending(true);
    setError(null);
    try {
      await reissue(orderId);
    } catch (cause) {
      setError(orderErrorMessage(cause));
    } finally {
      setPending(false);
    }
  };
  return (
    <div>
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={pending}
        onClick={() => {
          void submit();
        }}
      >
        다시 발행
      </Button>
      {error ? <p role="alert">{error}</p> : null}
    </div>
  );
};
